export function creditRequest(state = {
    fetching:false,
    fetched: false,
    error:null,
},{
    type,
    payload
}){
    
    switch(type){
        case "CREATE_CREDIT_START":           
        case "FETCH_CREDITS_START":                                 
        case "RECALC_CREDITS_START":                                 
        case "UPDATE_CREDIT_START":                                 
        case "DELETE_CREDIT_START":                                 
            return {
                ...state, 
                fetching:true,
            }        
        case "CREATE_CREDIT_FULFILLED":           
        case "FETCH_CREDITS_FULFILLED":                                 
        case "RECALC_CREDITS_FULFILLED":                                 
        case "UPDATE_CREDIT_FULFILLED":                                 
        case "DELETE_CREDIT_FULFILLED":                                 
            return {
                ...state,
                fetching:false, 
                fetched:true, 
                error: null
            }    
        case "CREATE_CREDIT_ERROR":
        case "FETCH_CREDITS_ERROR":
        case "RECALC_CREDITS_ERROR":
        case "UPDATE_CREDIT_ERROR":
        case "DELETE_CREDIT_ERROR":
            return {
                ...state,
                fetching:false, 
                error:payload
            }
        default:
            return state;
    }
    
}